<template>
  <div class="line-item">
    <fieldset>
      <legend class="visuallyhidden">Line Item</legend>
      <div class="field">
        <div class="field-body">
          <div class="field item-name">
            <label class="label input-wrapper" :class="{ active: this.lineItem.itemName.length }">
              <span class="input-label">Name</span>
              <input v-model="lineItem.itemName" v-validate="'required'" name="item_name" class="input" type="text" placeholder="Item">
              <span class="form-messages">{{ errors.first('item_name') }}</span>
            </label>
          </div>
          <div class="field item-description">
            <label class="label input-wrapper" :class="{ active: this.lineItem.description.length }">
              <span class="input-label">Description</span>
              <input v-model="lineItem.description" class="input" type="text" placeholder="Description">
            </label>
          </div>
          <div class="field item-quantity">
            <label class="label input-wrapper active" :class="{ active: this.lineItem.quantity }">
              <span class="input-label">Quantity</span>
              <input v-model="lineItem.quantity" class="input" type="number" placeholder="Quantity">
            </label>
          </div>
          <div class="field item-price">
            <label class="label input-wrapper active" :class="{ active: this.lineItem.price }">
              <span class="input-label">Price</span>
              <input v-model="lineItem.price" class="input" type="text" placeholder="Price">
            </label>
          </div>
          <div class="field item-total">
            <label class="label input-wrapper" :class="{ active: this.showTotal }">
              <span class="input-label">Total</span>
              <input class="input input-static" type="text" placeholder="Item Total" :value="itemTotal" readonly>
            </label>
          </div>
          <div class="field action-field">
            <button type="button" class="button icon-button icon-button-remove" @click="$emit('removeLineItem', lineItem.id)" title="Remove Item">
              <svg aria-hidden="true" focusable="false" data-icon="minus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon remove-icon"><path d="M140 274c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v12c0 6.6-5.4 12-12 12H140zm364-18c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z" class=""></path></svg>
              <span class="icon-button-link">Remove line item</span>
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'InvoiceFormLineItem',
  props: {
    lineItem: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showTotal: true
    }
  },
  computed: {
    itemTotal: function () {
      if (this.lineItem.quantity && this.lineItem.price) {
        return this.lineItem.quantity * this.lineItem.price
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/Variables.scss';

.line-item {
  border-bottom: 1px solid $grey;
  margin-bottom: 2rem;
  .field.action-field {
    align-items: center;
    display: flex;
    justify-content: center;
    .icon-button-remove {
      color: $red;
      margin-bottom: 15px;
      svg {
        fill: $red;
      }
      &:hover {
        color: #a62813;
        svg {
          fill: #a62813;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  .line-item {
    border-bottom: 0;
    margin-bottom: 1rem;
    .field {
      .field-body {
        > .field {
          &.item-name {
            flex: 1 1 20%;
          }
          &.item-quantity {
            flex: 1 1 15%;
          }
          &.item-price {
            flex: 1 1 15%;
          }
          &.item-total {
            flex: 1 1 15%;
          }
          &.action-field {
            flex: 0 1 auto;
            .icon-button-remove {
              .icon-button-link {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
